import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/components/core/_infrastructure/classes/services/global.service';
import { FilterSearchingBaseViewModel, Tc } from 'src/app/components/core/_infrastructure/types/common';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { FilterSearchingProgramaVerificacionViewModel, ProgramaVerificacionItemResultsViewModel } from '../buscador-pvcam.types';
import { BuscadorProgramaVerificacionService } from '../buscador-pvcam.service';
import { NavMenuService } from '../../../../core/components/navmenu/navmenu.service';

@Component({
    selector: 'app-buscador-pvcam-wrapper',
    templateUrl: './buscador-pvcam-wrapper.component.html',
})
export class BuscadorPvCamWrapperComponent extends ComponentBase implements OnInit {
    visibilitySpinner = false;
    searching = false;
    result: ProgramaVerificacionItemResultsViewModel | null;
    payload?: FilterSearchingProgramaVerificacionViewModel;

    listEstadosPv: Tc[];
    listBoxEstadosPv: Tc[] = [];
    listCampanias: Tc[];
    listComunidades: Tc[];

    private route = '/campanias/programaverificacion/datosbasicos';

    constructor(
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private globalService: GlobalService,
        private pvCamService: BuscadorProgramaVerificacionService,
        private router: Router,
        private navMenuService: NavMenuService,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit(): void {
        this.getEstadosPv();
        this.getCampanias();
        this.getComunidades();
        this.recoverLastSearch();
        //this.habilitarEditar = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.NUEVO_PERIODO).Visible;
    }

    /**
     * We try to get back the previous search done by the user.
     */
    private recoverLastSearch() {
        this.payload = this.pvCamService.getLastSearch();
    }

    private getEstadosPv(): void {
        this.globalService.getEstadoPV().subscribe((resultEstados: Tc[]) => {
            this.listEstadosPv = resultEstados;
        });
    }

    private getCampanias(): void {
        this.globalService.getAllCampanias().subscribe((resultCampanias: Tc[]) => {
            this.listCampanias = resultCampanias;
        });
    }

    private getComunidades(): void {
        this.globalService.getComunidadesAutonomas().subscribe((resultComunidades: Tc[]) => {
            this.listComunidades = resultComunidades;
        });
    }

    /**
     * Respond to the action of searching on variedad-filter.
     * It will send the filter to the backend and set the response.
     * @param payload FilterSearchingProgramaVerificacionViewModel
     * @return void
     */
    onSearch(payload: FilterSearchingProgramaVerificacionViewModel): void {
        this.payload = { ...payload } as FilterSearchingProgramaVerificacionViewModel; // To keep a copy to be used in the lazy search (paginator)
        if (!payload) {
            return;
        }
        this.pvCamService.getList(payload).subscribe(results => {
            this.result = results;
            this.searching = true;
        });
    }

    /**
     * It will be invoked when using the paginator
     * @param lazyLoadParams FilterSearchingBaseViewModel
     * @return void
     */
    onSearchLazy(lazyLoadParams: FilterSearchingBaseViewModel): void {
        const payload = {
            ...this.payload,
            PageNumber: lazyLoadParams.PageNumber,
            Asc: lazyLoadParams.Asc,
            OrderBy: lazyLoadParams.OrderBy,
        } as FilterSearchingProgramaVerificacionViewModel;
        this.onSearch(payload);
    }

    /**
     * Invoked when the user wants to clear the form
     * @return void
     */
    onReset(): void {
        this.searching = false;
        this.result = null;
        this.pvCamService.clearLastSearch();
        this.listBoxEstadosPv = [];
        this.navMenuService.clearMenuServiceForProgramaVerificacion();
    }

    onAddEstadoPv(idEstadoPv: number) {
        let currentEstadoPv = new Tc();
        currentEstadoPv.Id = idEstadoPv;
        //Comprobamos que no esté ya incluido
        let yaIncluido = this.listBoxEstadosPv.find(it => it.Id == currentEstadoPv.Id);
        if (yaIncluido) {
            return;
        }
        //Si no está incluido todavía, actualizamos el listbox
        let estadoPvSeleccionado = this.listEstadosPv.find(it => it.Id == idEstadoPv);
        currentEstadoPv.Descripcion = estadoPvSeleccionado!.Descripcion;
        this.listBoxEstadosPv.push(currentEstadoPv);
    }

    onDeleteEstadoPv(item: Tc) {
        this.listBoxEstadosPv.splice(this.listBoxEstadosPv.indexOf(item), 1);
    }

    /**
     * Redirigimos al formulario de edición.
     * Cuando el parámetro sea null, el backend captura el error y se muestra en pantalla.
     * @param itemId number|null
     * @return void
     */
    onEdit(itemId: number | null): void {
        this.router.navigate([this.route + '/edit', itemId]);
    }

    /**
     * Invoked when the user wants to export the result to excel
     * @return void
     */
    onExportExcel(): void {
        this.visibilitySpinner = true;

        const model: FilterSearchingProgramaVerificacionViewModel = new FilterSearchingProgramaVerificacionViewModel();
        Object.assign(model, this.payload);

        this.pvCamService.export(model).subscribe({
            next: res => {
                this.OpenDownloadedFile(res);
                this.visibilitySpinner = false;
            },
            error: error => {
                this.catchServerError(error);
                this.visibilitySpinner = false;
            },
        });
    }

    /**
     * To check whether there are results to export
     * @returns boolean
     */
    exportIsAvailable(): boolean {
        return this.result?.ResultList ? this.result?.ResultList?.length > 0 : false;
    }
}
